import classie from 'classie';

(function() {
	'use strict';
	
	var Nav = ctme.Nav = function () { },
	    nav = document.getElementById('nav'),
	    navBtn = document.getElementById('navicon'),
	    body = document.getElementsByTagName('body')[0],
	    border = document.getElementsByClassName('js-border')[0],
	    parent = document.getElementsByClassName('js-parent');
	    
    let status = false;

	Nav.prototype.navicon = function() {

		var showNav = function action(e) {

                classie.toggle(border, 'u-border');
			    classie.toggle(nav, 'is-visible');
                classie.toggle(navBtn, 'icon-hamburger');
                classie.toggle(navBtn, 'icon-close');	
                classie.toggle(body, 'no-overflow');	
                
                var items = nav.getElementsByTagName('li');
                
                for (var i = 0; i < items.length; i ++) {
                    classie.remove( items[i] , 'is-active' );
                }
                
                status = true;

    			e.returnValue = false;	
    		};
		
		const showSubmenu = function(e) {
            if (window.innerWidth <= 1024) {
                
                let bigmenu = e.currentTarget.nextElementSibling;
                
                for (let i = 0; i < document.getElementsByClassName('js-bigmenu').length; i++) {
            		document.getElementsByClassName('js-bigmenu')[i].classList.remove('is-active');
        		}
        		
        		for (let i = 0; i < parent.length; i++) {
            		parent[i].classList.remove('is-active');
        		}
                
                e.currentTarget.classList.add('is-active');
                
                bigmenu.classList.add('is-active');
        		e.preventDefault() ? e.preventDefault() : e.preventDefault = false;
    		}
		}
		
		for (let i = 0; i < parent.length; i++) {
    		parent[i].addEventListener('click', showSubmenu);
		}
		
		
		navBtn.addEventListener('click', showNav);
		
		window.addEventListener('resize', function() {
    		if ((window.innerWidth > 1024) && (status)) {
        		
        		ctme.Nav.closeMenu();
    		}
		});
	};
	
	Nav.prototype.submenu = function() {
    	
    	var items = nav.getElementsByTagName('li');

        var action = function(e) {
            alert('s');
            if (e.target.parentNode.classList.contains('is-active')) {
                classie.toggle( e.target.parentNode, 'is-active' );
            } else {
                for (var i = 0; i < items.length; i ++) {
                    classie.remove( items[i], 'is-active' );
                }
                classie.add( e.target.parentNode, 'is-active' );
            }
            e.returnValue = false;
        };

/*
        nav.addEventListener('click', function(e) {
            
            if (window.innerWidth <= 1024) {
                if (e.target.classList.contains('js-parent')) action(e);
            }

        });
*/
	};
	
	Nav.prototype.closeMenu = function() {
	    var items = nav.getElementsByTagName('li');

        for (var i = 0; i < items.length; i ++) {
            classie.remove( items[i] , 'is-active' );
        }
        
        for (let i = 0; i < document.getElementsByClassName('js-bigmenu').length; i++) {
    		document.getElementsByClassName('js-bigmenu')[i].classList.remove('is-active');
		}
        
	    classie.add(border, 'u-border');
    	classie.remove(nav, 'is-visible');
        classie.remove(navBtn, 'icon-close');
        classie.add(navBtn, 'icon-hamburger');
        classie.remove(body, 'no-overflow');
        
        status = false;
	};
	
	Nav.prototype.init = function() {	
        ctme.Nav.navicon();
        
        // Hide menu on ESC

        document.addEventListener('keydown', function(evt) {
            // evt = evt || window.event;
            var isEscape = false;
            if ("key" in evt) {
                isEscape = (evt.key == "Escape" || evt.key == "Esc");
            } else {
                isEscape = (evt.keyCode == 27);
            }
            if (isEscape) {
                ctme.Nav.closeMenu();
            }
        });
	};

	ctme.Nav = new Nav();	


}(window.ctme = window.ctme || {}));
